import { FC } from 'react';
import { ATTIO_OPPORTUNITIES_FILTER } from 'dashboard409a/common/constants/analyst-dashboard';
import WorkboardDataTable from '../WorkboardDataTable';

const WorkboardOpportunities: FC = () => (
  <WorkboardDataTable
    filters={ATTIO_OPPORTUNITIES_FILTER}
  />
);

export default WorkboardOpportunities;

